module.exports = __webpack_public_path__ + "static/media/26.cc766d73.jpg";